'use client';
import { FetcherError } from '#pplx/frontend/fetcher/errors.js';
import React, { useEffect } from 'react';
export const ThrowFetcherError = React.memo(function ThrowFetcherError({ error }) {
    throw error;
});
export function HardRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);
    return null;
}
//# sourceMappingURL=searchComponents2.js.map